import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useConfig } from '@xingternal/hops';
import { Button } from '@xingternal/button';

import Picture from '../Picture/Picture';

import jobsfinderIllustrationJpg from './images/jobsfinder.png';
import jobsfinderIllustrationWebp from './images/jobsfinder.webp';

import {
  SuggestionButton,
  ImageContainer,
  Container,
  Subtitle,
  Content,
  Hero,
  CtaText,
  InnerContainer,
} from './JobsfinderSection.style';

const JobsfinderSection = () => {
  const { externalUrl } = useConfig();
  const buttons = [
    'CONSULTING',
    'LOGISTICS',
    'IT',
    'MARKETING',
    'PROJECT_MANAGEMENT',
    'MORE_JOBS',
  ];

  return (
    <Container>
      <InnerContainer>
        <ImageContainer>
          <FormattedMessage id="WELCOME_STARTPAGE_JOBSFINDER_IMG_ALT">
            {text => (
              <Picture
                bitmapSrc={jobsfinderIllustrationJpg}
                webpSrc={jobsfinderIllustrationWebp}
                alt={text}
              />
            )}
          </FormattedMessage>
        </ImageContainer>
        <Content>
          <Hero forwardedAs="h2">
            <FormattedMessage id="WELCOME_STARTPAGE_JOBSFINDER_TITLE" />
          </Hero>
          <Subtitle>
            <FormattedMessage id="WELCOME_STARTPAGE_JOBSFINDER_SUBTITLE" />
          </Subtitle>
          <div>
            {buttons.map(keywordTranslationIdSuffix => (
              <FormattedMessage
                id={`WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_${keywordTranslationIdSuffix}`}
                key={keywordTranslationIdSuffix}
              >
                {keyword => {
                  let link;
                  const trackingString = `sc_o=losp_jobs_cluster_button_click&sc_o_PropActionOrigin=losp_jobs_cluster_${keywordTranslationIdSuffix}`;

                  if (keywordTranslationIdSuffix === 'MORE_JOBS') {
                    link = `${externalUrl}/jobs?${trackingString}`;
                  } else {
                    link = `${externalUrl}/jobs/search?page=1&keywords=${encodeURIComponent(
                      keyword
                    )}&${trackingString}`;
                  }

                  return (
                    <SuggestionButton
                      href={link}
                      variant="secondary"
                      size="medium"
                      sizeConfined="large"
                    >
                      {keyword}
                    </SuggestionButton>
                  );
                }}
              </FormattedMessage>
            ))}
          </div>
          <CtaText>
            <FormattedMessage id="WELCOME_STARTPAGE_JOBSFINDER_CTA_TEXT" />
          </CtaText>
          <Button
            variant="primary"
            size="large"
            href={`${externalUrl}/start/signup?sc_o=losp_sign_up_button_click&sc_o_PropActionOrigin=losp_sign_up_button_click_cta_2`}
          >
            <FormattedMessage id="WELCOME_STARTPAGE_JOBSFINDER_CTA_BUTTON" />
          </Button>
        </Content>
      </InnerContainer>
    </Container>
  );
};

export default JobsfinderSection;
